import { Dialog } from '@mui/material'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

type Props = {
	open: boolean
	email: string
	onClose: () => void
}
function ResetPasswordSuccessDialog({ open, email, onClose }: Props): JSX.Element {
	return (
		<Dialog open={open} onClose={onClose}>
			<MDBox width={'30rem'} height={'15rem'} style={{ backgroundColor: '#fff' }}>
				<MDBox
					p={3}
					display={'flex'}
					flexDirection={'column'}
					justifyContent={'center'}
					alignItems={'center'}
					width={'100%'}
					gap={1}
				>
					<MDTypography variant="h4">Check Your Email</MDTypography>
					<MDTypography variant="body2" mt={1}>
						If this email <i>{email}</i> is associated with Mockingbird, we will send you an email
						with a link to reset your password.
						<br />
						<br />
						Can’t find the email? Try checking your spam folder.
					</MDTypography>
				</MDBox>
			</MDBox>
		</Dialog>
	)
}

export default ResetPasswordSuccessDialog
